import { IFetchedImageDetail } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

//어드민 - 이미지 수정 페이지: 기존에 저장된 이미지의 옵션값 태그 불러오기
async function getAdminImageDetail(imageId?: number): Promise<AxiosResponse<FetchResult<IFetchedImageDetail>>> {
  const response = await instance.get(`/admin/images/${imageId}/detail`);
  return response;
}

// 사용자 액션에 따라 데이터를 조회해야 하므로 useMutation 이용
const useFetchAdminImageDetail = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['get', `/admin/images/:id/detail`],
    mutationFn: (imageId?: number) => getAdminImageDetail(imageId),
    retry: false
  });

  return { mutateAsync, isPending };
};

export default useFetchAdminImageDetail;
